import React, { Component } from 'react'

import Grid from '@material-ui/core/Grid'

import ContentNode from '../ContentNode/ContentNode'

import styles from '../../styles.js'

class Footer extends Component {
  state = {
    nodes: []
  }

  componentWillReceiveProps(props) {
    this.setState({
      nodes: this.props.nodes
    })
  }

  render() {
    return (
      <footer id="footer" style={{ ...styles.footer }}>
        <div style={{ ...styles.contentDark }}>
          <Grid className="panel" container direction="row" justify="center" alignItems="center">
            <div style={{ ...styles.content, ...styles.footerContent }}>
              <Grid container direction="row" justify="space-between" alignItems="flex-start">
                <Grid item xs={12} sm={6} md={3}>
                  <h5>
                    <ContentNode path="footer.column1.heading" nodes={this.state.nodes} />
                  </h5>
                  <ContentNode path="footer.column1.text" nodes={this.state.nodes} />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <h5>
                    <ContentNode path="footer.column2.heading" nodes={this.state.nodes} />
                  </h5>
                  <ContentNode path="footer.column2.text" nodes={this.state.nodes} />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <h5>
                    <ContentNode path="footer.column3.heading" nodes={this.state.nodes} />
                  </h5>
                  <ContentNode path="footer.column3.text" nodes={this.state.nodes} />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <h5>
                    <ContentNode path="footer.column4.heading" nodes={this.state.nodes} />
                  </h5>
                  <ContentNode path="footer.column4.text" nodes={this.state.nodes} />
                </Grid>
              </Grid>
            </div>
          </Grid>
        </div>
      </footer>
    )
  }
}

export default Footer


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js